export default {
  paper: {
    width: '550px',
  },
};
